/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createForEachTransform } from '../../factoriesAny.js';
export var forEachTransformDependencies = {
  typedDependencies: typedDependencies,
  createForEachTransform: createForEachTransform
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesForEachTransform.generated.js
// module id = 1552
// module chunks = 0